import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ThankyouComponent } from './pages/thankyou/thankyou.component';
import { SurveyComponent } from './pages/survey/survey.component';
import { SupplierAuthComponent } from './pages/supplier-auth/supplier-auth.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { SurveyStatusComponent } from './pages/survey-status/survey-status.component';
import { CaptchaComponent } from './pages/captcha/captcha.component';
import { TextanalyzerComponent } from './pages/textanalyzer/textanalyzer.component';
import { AffiliatePreScreen } from './pages/affiliate-prescreen/affiliate-prescreen.component';

const routes: Routes = [
    
    { path: '', redirectTo: 'not-found', pathMatch: 'full' },
    { path: 'survey/home', component: HomeComponent },
    { path: 'survey/supplier-auth', component: SupplierAuthComponent },
    { path: 'survey/survey', component: SurveyComponent },
    { path: 'survey/thankyou', component: ThankyouComponent },
    { path: 'survey/not-found', component: NotFoundComponent },
    { path: 'survey/captcha', component: CaptchaComponent },
    { path: 'survey/textanalyzer', component: TextanalyzerComponent },
    { path: 'survey/survey-status', component: SurveyStatusComponent },
    { path: 'survey/affiliate-prescreen', component: AffiliatePreScreen },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
